/**
 * Get the count of items in the square grid container from it's height.
 * @param {number} columnCount
 * @param {number} containerHeight
 * @param {number} itemSize
 * @param {number} rowGap
 * @returns {number}
 */
const getItemCount = (columnCount, containerHeight, itemSize, rowGap) => {
  // If container is smaller than item, none could fit.
  if (containerHeight < itemSize) {
    return 0;
  }
  // Count the items and gaps after the first item and then add the first one.
  return Math.ceil((containerHeight - itemSize) / (itemSize + rowGap)) * columnCount + 1;
};

export default getItemCount;
